module.exports = __webpack_public_path__ + "img/JobInfo.bc732b15.svg";